<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营商管理</el-breadcrumb-item>
      <el-breadcrumb-item>运营商采购</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <el-row :gutter="24" v-if="SubRule_ErpDlsOrder_Add">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="card_title">创建订单
                <el-button type="text" @click="clicktitle()">点击可以查看视频教程</el-button>
              </div>
              <el-form :model="addForm" ref="addFormRef" label-width="130px">
                <el-form-item label="选择价格主体门店" class="addAdminForm" v-if="SubRule_ErpDlsOrder_DaiKeXiaDan">
                  <Rsljigou :propsjigouid="addForm.daikexiadanjigouid" :propsjigouname="addForm.daikexiadanjigouname" @change="changeaddFormRsljigouDaikexiadan"></Rsljigou>
                </el-form-item>
                <el-form-item label="选择门店" class="addAdminForm">
                  <Rsljigou :propsjigouid="addForm.selectjigouid" :propsjigouname="addForm.selectjigouname" @change="changeaddFormRsljigou"></Rsljigou>
                </el-form-item>
                <el-form-item label="选择产品" class="addAdminFormLong">
                  <div class="productdata1">
                    <div class="productdata2">
                      <el-select v-model="addForm.bomsn" @change="changeselect" placeholder="产品" style="width: 20%" class="rengongdata3">
                        <el-option
                          v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      库存:
                      <el-input v-model="addForm.kucun" placeholder="库存" style="width: 16%"></el-input>
                      下单数量:
                      <el-input v-model="addForm.num" placeholder="数量" style="width: 16%"></el-input>
                      <el-button type="text" @click="clickaddproduct()">增加</el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="已选产品" class="addAdminFormLong">
                  <div class="productdata1">
                    <div class="productdata2" v-for="rgitem in addForm.productList" :key="rgitem.index">
                      <el-select v-model="rgitem.bomsn" placeholder="请选择产品" style="width: 20%" class="rengongdata3" :disabled="true">
                        <el-option
                          v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      单价:
                      <el-input v-model="rgitem.money" placeholder="单价" :disabled="true" style="width: 16%"></el-input>
                      数量:
                      <el-input v-model="rgitem.num" placeholder="数量" :disabled="true" style="width: 16%"></el-input>
                      价格:
                      <el-input v-model="rgitem.moneytotal" placeholder="自动计算价格" :disabled="true" style="width: 16%"></el-input>
                      <el-button type="text" @click="clickdeleteproduct(rgitem)">删除</el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="收款信息" class="addAdminFormLong">
                  <el-card v-for="payitem in addForm.paymentaccountList" :key="payitem.accountname">
                    <li>账户名称：{{payitem.accountname}}</li>
                    <li>账号：{{payitem.accountnumber}}</li>
                    <li>开户行：{{payitem.accountbank}}</li>
                    <li>金额：{{payitem.moneytotal}}</li>
                  </el-card>
                </el-form-item>
                <el-form-item label="总金额" class="addAdminForm">
                  <el-input v-model="addForm.moneytotal" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="收件姓名" class="addAdminForm">
                  <el-input v-model="addForm.name" placeholder="请输入收件人姓名"></el-input>
                </el-form-item>
                <el-form-item label="收件手机" class="addAdminForm">
                  <el-input v-model="addForm.phone" placeholder="请输入收件人手机"></el-input>
                </el-form-item>
                <el-form-item label="收件地址" class="addAdminForm">
                  <el-input v-model="addForm.address" placeholder="请输入收件人地址"></el-input>
                </el-form-item>
                <el-form-item label="备注" class="addAdminForm">
                  <el-input v-model="addForm.beizhu" placeholder="请输入备注(可选)"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="clickadd">添加</el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div class="card_title">我的订单设备数量汇总</div>
              <ve-line :data="myOrderData" :legend-visible="false" :colors="dataColors"></ve-line>
            </el-card>
          </el-col>

<!--          <el-col :span="12">
            <el-card class="box-card">
              <div class="card_title">产品库存</div>
              <ve-histogram :data="kucunData" :extend="kucunExtend" :legend-visible="false" :colors="dataColors"></ve-histogram>
            </el-card>
          </el-col> -->
        </el-row>

<!--        <el-row :gutter="24" v-if="SubRule_ErpDlsOrder_Add">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="card_title">我的订单设备数量汇总</div>
              <ve-line :data="myOrderData" :legend-visible="false" :colors="dataColors"></ve-line>
            </el-card>
          </el-col>

          <el-col :span="12">
            <el-card class="box-card">
              <div class="card_title">所有运营商订单设备数量汇总</div>
              <ve-pie :data="allOrderData" :legend-visible="false"></ve-pie>
            </el-card>
          </el-col>
        </el-row> -->

        <el-card class="box-card">
          <div class="card_title">我的订单明细</div>
          <!-- 筛选条件 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item label="">
              <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select">
                <el-option label="请选择订单状态" value="-1"></el-option>
                <el-option label="已创建,待支付" value="0"></el-option>
                <el-option label="已支付,待审核" value="1"></el-option>
                <el-option label="已审核,待发货" value="2"></el-option>
                <el-option label="已部分发货" value="3"></el-option>
                <el-option label="已全部发货" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="keywords.jigouquerymode" placeholder="" class="select2">
                <el-option label="查询所选机构的订单" value="1"></el-option>
                <el-option label="查询所选机构和下级的订单" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入收件人姓名"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="keywords.invoicestatus" placeholder="" class="select2">
                <el-option label="请选择开票状态" value="-1"></el-option>
                <el-option label="未开票" value="0"></el-option>
                <el-option label="已开票" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="keywords.ordertype" placeholder="" class="select2">
                <el-option label="按订单创建时间排序" value="1"></el-option>
                <el-option label="按财务审核时间排序" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="clicksearch">查询</el-button>
              <el-button type="success" @click="clickexcel(101)" v-if="SubRule_ExcelErpDlsOrder">导出订单发货汇总</el-button>
              <el-button type="success" @click="clickexcel(104)" v-if="SubRule_ExcelErpDlsOrder">导出订单发货明细</el-button>
            </el-form-item>
          </el-form>
          <!-- 筛选条件 end -->
          <!-- 数据列表 start -->
          <el-table v-loading="loading" :data="dataList" @expand-change="expandchange" ref="dataList" border stripe>
            <el-table-column type="expand" min-width="1%">
              <template slot-scope="props">
                <el-table :data="props.row.Sublist" height="200" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
                  <el-table-column label="产品名称"  prop="Pname"></el-table-column>
                  <el-table-column label="订单数量" prop="Num"></el-table-column>
                  <el-table-column label="已发货数量" prop="Numsend"></el-table-column>
                  <el-table-column label="单价" prop="Money" v-if="SubRule_ErpDlsOrder_Jiage"></el-table-column>
                  <el-table-column label="总价" prop="Moneytotal" v-if="SubRule_ErpDlsOrder_Jiage"></el-table-column>
                  <el-table-column label="开票状态" prop="InvoicestatusName" v-if="SubRule_ErpDlsOrder_Caiwushenhe"></el-table-column>
                  <el-table-column prop="operation" label="操作">
                    <template v-slot="scope">
                      <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Invoicestatus == 0 && SubRule_ErpDlsOrder_Caiwushenhe" @click="apiEditerpordersubinvoicestatus(scope.row,1)">切换为已开票</el-button>
                      <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Invoicestatus == 1 && SubRule_ErpDlsOrder_Caiwushenhe" @click="apiEditerpordersubinvoicestatus(scope.row,0)">切换为未开票</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="Orderid" label="订单号" min-width="10%"></el-table-column>
            <el-table-column prop="Orderstatuss" label="订单状态(点击查看清单)" min-width="8%">
              <template slot-scope="props">
                <span class="blue" style="margin-left: 0; margin-right: 5px;color: #48c9b0;" @click="toogleExpand(props.row)">{{props.row.Orderstatuss}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Moneytotal" label="总价" min-width="6%" v-if="SubRule_ErpDlsOrder_Jiage"></el-table-column>
            <el-table-column prop="FreightWay" label="运费" min-width="6%"></el-table-column>
            <el-table-column label="支付凭证" min-width="6%"  v-if="SubRule_ErpDlsOrder_Jiage">
              <template v-slot="scope">
                <el-button v-for="Payimage in scope.row.Payimages" type="text" @click="clickfile(Payimage)">点击查看</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="Jigouname" label="机构名称" min-width="7%"></el-table-column>
            <el-table-column prop="Fukuanname" label="付款方单位名称" min-width="8%"></el-table-column>
            <el-table-column prop="Address" label="收件人地址" min-width="9%"></el-table-column>
            <el-table-column prop="Name" label="收件人姓名" min-width="7%"></el-table-column>
            <el-table-column prop="Phone" label="收件人手机" min-width="7%"></el-table-column>
            <el-table-column prop="Caiwushenhetime" label="财务审核" min-width="7%"></el-table-column>
            <el-table-column prop="Createtime" label="创建时间" min-width="7%"></el-table-column>
            <el-table-column prop="Invoicestatuss" label="开票状态" min-width="7%" v-if="SubRule_ErpDlsOrder_Caiwushenhe"></el-table-column>
            <el-table-column prop="operation" label="操作" min-width="8%">
              <template v-slot="scope">
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus == 0 && SubRule_ErpDlsOrder_Delete" @click="clickdelete(scope.row)">删除</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus == 0 && SubRule_ErpDlsOrder_Add" @click="clickedit(scope.row)">编辑</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_ErpDlsOrder_Jiage" @click="clickshoukuan(scope.row)">查看收款信息</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus == 0 && SubRule_ErpDlsOrder_Payimage" @click="clickpayimage(scope.row)">线下:提交支付凭证</el-button>
<!--                <el-link size="mini" style="margin-left: 0; margin-right: 5px;color: #48c9b0;" v-if="scope.row.Orderstatus == 0 && SubRule_ErpDlsOrder_Payonline" :href="scope.row.PayUrl" target="_blank">线上:扫码支付</el-link> -->
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_ErpDlsOrder_Add" @click="clickGenerateFuOrder(scope.row)">生成负订单</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus == 1 && SubRule_ErpDlsOrder_Caiwushenhe" @click="clickcaiwushenhe(scope.row)">财务审核</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Invoicestatus == 0 && SubRule_ErpDlsOrder_Caiwushenhe" @click="apiEditerporderinvoicestatus(scope.row,1)">切换为已开票</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Invoicestatus == 1 && SubRule_ErpDlsOrder_Caiwushenhe" @click="apiEditerporderinvoicestatus(scope.row,0)">切换为未开票</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus == 2 && SubRule_ErpDlsOrder_Caiwushenhe" @click="clickcaiwuqishen(scope.row)">财务弃审</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus >= 2 && SubRule_ErpDlsOrder_Wuliu" @click="clickwuliu(scope.row)">发货管理</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus >= 2 && SubRule_ErpDlsOrder_DeliveryRecord" @click="clickDeliveryRecord(scope.row)">发货记录</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickbeizhu(scope.row)">备注管理</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 数据列表 end -->
          <!-- 分页 -->
          <div class="pages">
            <el-pagination
              @current-change="handleCurrentPageChange"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="dataListnum"
			  :current-page.sync="selectedPageNo">
            </el-pagination>
          </div>
        </el-card>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 提交支付凭证弹出框 -->
    <el-dialog title="提交支付凭证" :visible.sync="payimagedialog" width="30%" :close-on-click-modal="false">
      <el-form :model="payimageForm" ref="payimageFormRef" label-width="120px">
        <el-form-item label="支付凭证" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item label="付款方单位名称" class="addAdminForm">
          <el-input v-model="payimageForm.fukuanname"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksavepayimage">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 提交支付凭证弹出框 end -->

    <!-- 财务审核弹出框 -->
    <el-dialog title="财务审核" :visible.sync="caiwushenhedialog" width="30%" :close-on-click-modal="false">
      <el-form :model="caiwushenheForm" ref="caiwushenheFormRef" label-width="70px">
        <el-form-item label="支付凭证" class="addAdminForm">
          <el-image
            style="width: 100px; height: 100px"
            :src="caiwushenheForm.payimage"
            :preview-src-list="caiwushenheForm.payimagelist">
          </el-image>
          点击放大
        </el-form-item>
        <el-form-item label="付款名称" class="addAdminForm">
          <el-input v-model="caiwushenheForm.fukuanname"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="clickjujuecaiwushenhe">拒绝审核</el-button>
          <el-button type="primary" @click="clicksavecaiwushenhe">通过审核</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 财务审核弹出框 end -->

    <!-- 仓库发货弹出框 -->
    <el-dialog title="仓库发货" :visible.sync="wuliudialog" width="30%" :close-on-click-modal="false">
      <el-form :model="wuliuForm" ref="wuliuFormRef" label-width="70px">
        <el-form-item label="物流公司" class="addAdminForm">
          <el-input v-model="wuliuForm.logisticsname"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="wuliuForm.logisticsid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksavewuliu">发货</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 仓库发货弹出框 end -->

    <!-- 视频教程弹出框 -->
    <el-dialog @close="closevideodialog" @open="openvideodialog" title="视频教程" :visible.sync="videodialog" width="40%" :close-on-click-modal="false">
      <video ref="videodialog" src="https://erp-1256233047.cos.ap-shanghai.myqcloud.com/video/yunyingshangxiadan.mp4" controls="controls" autoplay="autoplay">
      您的浏览器不支持播放视频
      </video>
    </el-dialog>
    <!-- 视频教程弹出框 end -->

    <!-- 收款信息弹出框 -->
    <el-dialog title="收款信息" :visible.sync="paymentaccountdialog" width="35%" :close-on-click-modal="false">
      <el-card v-for="payitem in paymentaccountListRow" :key="payitem.accountname">
        <li>账户名称：{{payitem.accountname}}</li>
        <li>账号：{{payitem.accountnumber}}</li>
        <li>开户行：{{payitem.accountbank}}</li>
        <li>金额：{{payitem.moneytotal}}</li>
      </el-card>
    </el-dialog>
    <!-- 收款信息弹出框 end -->

    <el-tab-pane label="编辑" name="five" disabled="disabled">
      <ErpDlsOrderEdit ref="SubVuefive" v-on:triggerFunc="BackToFirst(1)"></ErpDlsOrderEdit>
    </el-tab-pane>

    <el-tab-pane label="发货管理" name="three" disabled="disabled">
      <ErpDlsOrderSend ref="SubVuethree" v-on:triggerFunc="BackToFirst(0)"></ErpDlsOrderSend>
    </el-tab-pane>

    <el-tab-pane label="备注管理" name="four" disabled="disabled">
      <ErpDlsOrderBeizhu ref="SubVuefour" v-on:triggerFunc="BackToFirst(0)"></ErpDlsOrderBeizhu>
    </el-tab-pane>

    <el-tab-pane label="发货记录" name="six" disabled="disabled">
      <ErpDlsOrderSendLog ref="SubVuesix" v-on:triggerFunc="BackToFirst(0)"></ErpDlsOrderSendLog>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import ErpDlsOrderSend from '@/componentsSubVue/ErpDlsOrderSend.vue'
import ErpDlsOrderSendLog from '@/componentsSubVue/ErpDlsOrderSendLog.vue'
import ErpDlsOrderBeizhu from '@/componentsSubVue/ErpDlsOrderBeizhu.vue'
import ErpDlsOrderEdit from '@/componentsSubVue/ErpDlsOrderEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    TencentyunCosUploadMultiImgOrPdf,
    ErpDlsOrderSend,
    ErpDlsOrderSendLog,
    ErpDlsOrderBeizhu,
    ErpDlsOrderEdit
  },
  name: 'MyErpDlsOrder',
  data () {
    this.kucunExtend = {
      series (v) {
        v.forEach(i => {
          i.barWidth = 20
        })
        return v
      },
      xAxis: {
        type: 'category',
        // data: ['1页', '2页', '3页', '4页', '5页', '6-10页', '11-20页', '20+页'],
        // xAxis的属性，设置x轴文本不隐藏，同理yAxis也有
        axisLabel: {
          interval: 0, // 坐标轴刻度标签的显示间隔
          rotate: 90 // 标签倾斜的角度
        }
      }
    }
    return {
      loading: false,
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        selectjigouid: '-1',
        selectjigouname: '',
        bomsn: '',
        kucun: '',
        num: '',
        productList: [],
        paymentaccountList: [],
        danjia: '',
        moneytotal: '',
        name: '',
        phone: '',
        address: '',
        beizhu: '',
        daikexiadanjigouid: '-1',
        daikexiadanjigouname: ''
      },
      timer: '',
      // 查询
      keywords: {
        orderid: '',
        orderstatus: '-1',
        jigouquerymode: '1',
        jigouid: '-1',
        jigouname: '',
        name: '',
        invoicestatus: '-1',
        ordertype: '1'
      },
      dataList: [],
      dataListnum: 0,
      payimagedialog: false,
      payimageForm: {
        id: '',
        payimage: '',
        fukuanname: ''
      },
      caiwushenhedialog: false,
      caiwushenheForm: {
        id: '',
        payimage: '',
        payimagelist: [],
        fukuanname: ''
      },
      wuliudialog: false,
      wuliuForm: {
        id: '',
        logisticsname: '',
        logisticsid: ''
      },
      selectedPageNo: 1,
      SubRule_ErpDlsOrder_Add: false,
      SubRule_ErpDlsOrder_Payimage: false,
      SubRule_ErpDlsOrder_Payonline: false,
      SubRule_ErpDlsOrder_Caiwushenhe: false,
      SubRule_ErpDlsOrder_Wuliu: false,
      SubRule_ErpDlsOrder_Receipt: false,
      SubRule_ErpDlsOrder_Jiage: false,
      SubRule_ErpDlsOrder_Delete: false,
      SubRule_ErpDlsOrder_DeliveryRecord: false,
      SubRule_ExcelErpDlsOrder: false,
      SubRule_ErpDlsOrder_DaiKeXiaDan: false,
      SubList: [],
      dataColors: ['#4ad2ff'],
      kucunData: {
        columns: ['name', '库存'],
        rows: []
      },
      myOrderData: {
        columns: ['name', '下单数量'],
        rows: []
      },
      allOrderData: {
        columns: ['name', '下单数量'],
        rows: []
      },
      ListKucun: [],
      videodialog: false,
      paymentaccountdialog: false,
      paymentaccountListRow: [],
      rowToogle: null
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
    this.apigeterpordernum()
    this.apigeterporderlist()
    this.apiGetallfinishedproductinventory()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_Add = true
      }
    })

    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_Payimage', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_Payimage = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_Payonline', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_Payonline = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_Caiwushenhe', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_Caiwushenhe = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_Wuliu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_Wuliu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_Receipt', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_Receipt = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_Jiage', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_Jiage = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_Delete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_Delete = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_DeliveryRecord', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_DeliveryRecord = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ExcelErpDlsOrder', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelErpDlsOrder = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_DaiKeXiaDan', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsOrder_DaiKeXiaDan = true
      }
    })
  },
  methods: {
    clicktitle () {
      this.videodialog = true
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    openvideodialog () {
      this.$refs.videodialog.play()
    },
    closevideodialog () {
      this.$refs.videodialog.pause()
    },
    BackToFirst (val) {
      this.activeName = 'first'
      if (val === 1) {
        this.apigeterpordernum()
        this.apigeterporderlist()
      }
    },
    clickexcel (exceltype) {
      this.apiExcelErpDlsOrder(exceltype)
    },
    expandchange (row, expanded) {
    },
    toogleExpand (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Id !== item.Id) {
          $table.toggleRowExpansion(item, false)
        }
      })
      $table.toggleRowExpansion(row)
      this.rowToogle = row
    },
    toogleExpandManual (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Id == item.Id) {
          $table.toggleRowExpansion(item, true)
        }
      })
    },
    changeselect (e) {
      var that = this
      that.ListKucun.forEach((item) => {
        if (item.Bomsn == e) {
          that.addForm.kucun = item.Num
        }
      })
    },
    clickshoukuan (row) {
      if (row.Paymentaccount.length > 0) {
        this.paymentaccountListRow = JSON.parse(row.Paymentaccount)
        this.paymentaccountdialog = true
      } else {
        Vue.prototype.FunAlertMsg('旧订单不存在收款信息')
      }
    },
    // 编辑管理
    clickedit (row) {
      this.activeName = 'five'
      this.$refs.SubVuefive.LoadData({ name: '', params: { orderid: row.Orderid, jigouid: row.Jigouid, name: row.Name, phone: row.Phone, address: row.Address } })
    },
    // 发货管理
    clickwuliu (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData({ name: '', params: { orderid: row.Orderid, jigouid: row.Jigouid } })
    },
    // 备注管理
    clickbeizhu (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData({ name: '', params: { orderid: row.Orderid, jigouid: row.Jigouid } })
    },
    // 发货记录
    clickDeliveryRecord (row) {
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData({ name: '', params: { orderid: row.Orderid, jigouid: row.Jigouid } })
    },
    clickaddproduct () {
      if (this.addForm.selectjigouname == '') {
        Vue.prototype.FunAlertMsg('请选择门店')
        return
      }
      if (this.addForm.bomsn == '') {
        Vue.prototype.FunAlertMsg('请选择产品')
        return
      }
      if (this.addForm.num == '') {
        Vue.prototype.FunAlertMsg('请输入数量')
        return
      }
      var danjia = parseFloat(this.addForm.danjia)
      var num = parseFloat(this.addForm.num)
      if (danjia <= 0) {
        Vue.prototype.FunAlertMsg('请输入有效单价')
        return
      }

      this.apigetproductjiage()
    },
    runaddproduct (danjia, num, accountname, accountnumber, accountbank) {
      danjia = Number(danjia)
      num = Number(num)
      var moneytotal = danjia * num
      moneytotal = +moneytotal.toFixed(2)
      var isfind = false
      // 先判断是否需要合并到已有的产品里
      for (var j = 0, len = this.addForm.productList.length; j < len; j++) {
        if (this.addForm.productList[j].bomsn === this.addForm.bomsn) {
          isfind = true
          this.addForm.productList[j].num = this.addForm.productList[j].num + num
          this.addForm.productList[j].money = danjia
          var moneytotalbuf = danjia * this.addForm.productList[j].num
          moneytotalbuf = +moneytotalbuf.toFixed(2)
          this.addForm.productList[j].moneytotal = moneytotalbuf
        }
      }
      // 如果没有，就新增
      if (!isfind) {
        var len2 = this.addForm.productList.length
        var obj2 = { index: len2 + 1, bomsn: this.addForm.bomsn, num: num, money: danjia, moneytotal: moneytotal, accountname: accountname, accountnumber: accountnumber, accountbank: accountbank }
        this.addForm.productList.push(obj2)
      }

      this.UpdateMoneyTotalAndPaymentAccount()
    },
    clickdelete (row) {
      this.$confirm('是否删除此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteErpOrder(row.Orderid)
      })
    },
    clickGenerateFuOrder (row) {
      this.$confirm('是否产生此订单的负向订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiGenerateFuOrder(row.Orderid)
      })
    },
    clickdeleteproduct (rgitem) {
      var buflist = []
      var addindex = 0
      for (var j = 0, len = this.addForm.productList.length; j < len; j++) {
        var index = this.addForm.productList[j].index
        if (index === rgitem.index) {
          addindex = -1
        } else {
          var obj = this.addForm.productList[j]
          obj.index += addindex
          buflist.push(obj)
        }
      }
      this.addForm.productList = buflist

      this.UpdateMoneyTotalAndPaymentAccount()
    },
    UpdateMoneyTotalAndPaymentAccount () {
      // 更新付款账号
      this.addForm.paymentaccountList = []
      for (var j = 0, len1 = this.addForm.productList.length; j < len1; j++) {
        var isfind = false
        for (var i = 0, len2 = this.addForm.paymentaccountList.length; i < len2; i++) {
          if (this.addForm.productList[j].accountname === this.addForm.paymentaccountList[i].accountname) {
            isfind = true
            this.addForm.paymentaccountList[i].moneytotal += this.addForm.productList[j].moneytotal
            this.addForm.paymentaccountList[i].moneytotal = +this.addForm.paymentaccountList[i].moneytotal.toFixed(2)
          }
        }
        if (!isfind) {
          this.addForm.paymentaccountList.push({
            accountname: this.addForm.productList[j].accountname,
            accountnumber: this.addForm.productList[j].accountnumber,
            accountbank: this.addForm.productList[j].accountbank,
            moneytotal: this.addForm.productList[j].moneytotal
          })
        }
      }
      // 更新总价
      var moneytotal = 0
      for (var j = 0, len = this.addForm.productList.length; j < len; j++) {
        moneytotal += this.addForm.productList[j].moneytotal
        moneytotal = +moneytotal.toFixed(2)
      }
      this.addForm.moneytotal = moneytotal
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.payimageForm.payimage = url
    },
    clickpayimage (row) {
      this.payimagedialog = true
      this.payimageForm.id = row.Id
      this.payimageForm.payimage = row.Payimage
    },
    clickcaiwushenhe (row) {
      this.caiwushenhedialog = true
      this.caiwushenheForm.id = row.Id
      this.caiwushenheForm.payimage = row.Payimage
      this.caiwushenheForm.payimagelist = [row.Payimage]
      this.caiwushenheForm.fukuanname = row.Fukuanname
    },
    clickcaiwuqishen (row) {
      this.$confirm('是否确认弃审?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiEditerpordercaiwuqishen(row)
      })
    },
    clickreceipt (row) {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiediterporderreceipt(row.Id)
      })
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    changeaddFormRsljigou (vid, vname) {
      this.addForm.selectjigouid = vid
      this.addForm.selectjigouname = vname
    },
    changeaddFormRsljigouDaikexiadan (vid, vname) {
      this.addForm.daikexiadanjigouid = vid
      this.addForm.daikexiadanjigouname = vname
    },
    clickadd () {
      if (!this.addForm.moneytotal) {
        this.$alert('请输入总价', '提示')
        return
      }
      if (!this.addForm.name) {
        this.$alert('请输入收件姓名', '提示')
        return
      }
      if (!this.addForm.phone) {
        this.$alert('请输入收件手机', '提示')
        return
      }
      if (!this.addForm.address) {
        this.$alert('请输入收件地址', '提示')
        return
      }
      this.apiaddproductorder()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksavepayimage () {
      if (!this.payimageForm.payimage) {
        this.$alert('请选择支付凭证', '提示')
        return
      }
      if (!this.payimageForm.fukuanname) {
        this.$alert('请输入付款方单位名称', '提示')
        return
      }
      this.apiediterporderpayimage()
    },
    clickjujuecaiwushenhe(){
      // 拒绝审核
      this.apiediterpordercaiwushenhe(0)
    },
    clicksavecaiwushenhe () {
      // 通过审核
      this.apiediterpordercaiwushenhe(1)
    },
    clicksavewuliu () {
      if (!this.wuliuForm.logisticsname) {
        this.$alert('请输入物流公司', '提示')
        return
      }
      if (!this.wuliuForm.logisticsid) {
        this.$alert('请输入物流单号', '提示')
        return
      }
      this.apiediterporderwuliu()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigeterpordernum()
      this.apigeterporderlist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigeterporderlist()
    },
    apigetproductjiage: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        selectjigouid: that.addForm.selectjigouid,
        daikexiadanjigouid: that.addForm.daikexiadanjigouid,
        bomsn: that.addForm.bomsn,
        num: that.addForm.num
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      console.log(data)
      axios.post(Vue.prototype.global.Url_Getproductjiage, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.runaddproduct(response.data.Money, response.data.Num, response.data.Accountname, response.data.Accountnumber, response.data.Accountbank)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype == 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigeterpordernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        jigouquerymode: that.keywords.jigouquerymode,
        jigouid: that.keywords.jigouid,
        name: that.keywords.name,
        invoicestatus: that.keywords.invoicestatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterpordernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigeterporderlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        jigouquerymode: that.keywords.jigouquerymode,
        jigouid: that.keywords.jigouid,
        name: that.keywords.name,
        invoicestatus: that.keywords.invoicestatus,
        ordertype: that.keywords.ordertype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterporderlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.addForm.address = response.data.Address
            that.addForm.name = response.data.Name
            that.addForm.phone = response.data.Phone
            if (that.addForm.selectjigouname == '') {
              that.addForm.selectjigouid = response.data.Curjigouid + ''
              that.addForm.selectjigouname = response.data.Curjigouname
            }
            for (var i = 0; i < that.dataList.length; i++) {
              if (that.dataList[i].Payimage.length > 5) {
                that.dataList[i].Payimages = that.dataList[i].Payimage.split('@@@')
              } else {
                that.dataList[i].Payimages = []
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiDeleteErpOrder: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteErpOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apigeterpordernum()
            that.apigeterporderlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGenerateFuOrder: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GenerateFuOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apigeterpordernum()
            that.apigeterporderlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddproductorder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        selectjigouid: this.addForm.selectjigouid,
        daikexiadanjigouid: that.addForm.daikexiadanjigouid,
        productlist: JSON.stringify(this.addForm.productList),
        moneytotal: this.addForm.moneytotal,
        name: this.addForm.name,
        phone: this.addForm.phone,
        address: this.addForm.address,
        paymentaccount: JSON.stringify(this.addForm.paymentaccountList),
        beizhu: this.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addproductorder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.addForm.productList = []
            that.addForm.paymentaccountList = []
            that.addForm.moneytotal = ''
            that.addForm.beizhu = ''

            that.activeName = 'first'
            that.apigeterpordernum()
            that.apigeterporderlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiediterporderpayimage: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.payimageForm.id,
        fukuanname: this.payimageForm.fukuanname,
        payimage: this.payimageForm.payimage
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerporderpayimage, Qs.stringify(data))
        .then(function (response) {
          that.apigeterporderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.payimagedialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiediterpordercaiwushenhe: function (sh) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.caiwushenheForm.id,
        sh:sh
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerpordercaiwushenhe, Qs.stringify(data))
        .then(function (response) {
          that.apigeterporderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.caiwushenhedialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditerpordercaiwuqishen: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerpordercaiwuqishen, Qs.stringify(data))
        .then(function (response) {
          that.apigeterporderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditerporderinvoicestatus: function (row, invoicestatus) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id,
        invoicestatus: invoicestatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerporderinvoicestatus, Qs.stringify(data))
        .then(function (response) {
          that.apigeterporderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditerpordersubinvoicestatus: function (row, invoicestatus) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id,
        invoicestatus: invoicestatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerpordersubinvoicestatus, Qs.stringify(data))
        .then(function (response) {
          that.apigeterporderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.toogleExpandManual(that.rowToogle)
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiediterporderwuliu: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.wuliuForm.id,
        logisticsname: this.wuliuForm.logisticsname,
        logisticsid: this.wuliuForm.logisticsid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerporderwuliu, Qs.stringify(data))
        .then(function (response) {
          that.apigeterporderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.wuliudialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiediterporderreceipt: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerporderreceipt, Qs.stringify(data))
        .then(function (response) {
          that.apigeterporderlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetallfinishedproductinventory: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getallfinishedproductinventory, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.kucunData.rows = []
            that.myOrderData.rows = []
            that.allOrderData.rows = []
            that.ListKucun = response.data.ListKucun
            response.data.ListKucun.forEach((item) => {
              that.kucunData.rows.push({ name: Vue.prototype.FunGetShortString(item.Name), 库存: item.Num })
            })
            response.data.ListMy.forEach((item) => {
              if (item.Num > 0) {
                that.myOrderData.rows.push({ name: Vue.prototype.FunGetShortString(item.Name), 下单数量: item.Num })
              }
            })
            response.data.ListAll.forEach((item) => {
              that.allOrderData.rows.push({ name: Vue.prototype.FunGetShortString(item.Name), 下单数量: item.Num })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelErpDlsOrder: function (exceltype) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        jigouquerymode: that.keywords.jigouquerymode,
        jigouid: that.keywords.jigouid,
        name: that.keywords.name,
        displaydanjia: that.SubRule_ErpDlsOrder_Jiage,
        exceltype: exceltype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErpDlsOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .cell {
      white-space: pre-wrap;
  }
</style>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select1 {
    width: 109px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

.productdata3 {
  padding-right: 5px;
}

.box-card{
    margin-top: 5px;
    margin-bottom: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
